import { axiosClient } from "@/shared/api/axios-client";
import type { CargarCFDIResultado } from "@/lib/types";

/**
 * P44 · FB60 Contrapago: el CFDI real llega DESPUÉS del pago. Misma respuesta
 * shape que la carga de CFDI normal (`CargarCFDIResultado`).
 */
export const conciliarCfdiContrapagoApi = {
  conciliar: (solicitudId: string, xml: File) => {
    const form = new FormData();
    form.append("cfdi", xml);
    return axiosClient
      .post<CargarCFDIResultado>(`/api/solicitudes/${solicitudId}/cfdi-contrapago`, form, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((r) => r.data);
  },
};
